import * as React from "react";
import * as Scrivito from "scrivito";
import MediaRightComponent from "./MediaRightComponent";
import MediaLeftComponent from "./MediaLeftComponent";

import "./TextMediaWidget.scss";

Scrivito.provideComponent("TextMediaWidget", ({ widget }) => {
  const title =
    widget.get("toUppercase") === "yes" ? (
      <Scrivito.ContentTag tag="h2" content={widget} attribute="title" />
    ) : (
      <div className="heading_without_upercase">
        <Scrivito.ContentTag tag="h2" content={widget} attribute="title" />
      </div>
    );

  const mediaPosition =
    widget.get("mediaPosition") === "left" ? (
      <MediaLeftComponent widget={widget} />
    ) : (
      <MediaRightComponent widget={widget} />
    );

  return (
    <div className="mb-6">
      {title}
      <div className="row">{mediaPosition}</div>
    </div>
  );
});
